if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	// WRAP TABLES
	document.querySelectorAll('.text table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableWrap');
		tableWrapper.setAttribute('data-fromjs', '1');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// MOBILE NAV SOCIAL MEDIA
	const navHolder = document.querySelector('.navigation');
	const footerSocial = document.querySelector('.footer .social-media');

	if (navHolder && footerSocial) {
		navHolder.insertAdjacentHTML('beforeend', footerSocial.outerHTML);
	}

	// CLOSE MAIN NAV MOBILE
	document.querySelectorAll('.close-menu').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.remove('active');
				document.body.classList.remove('noscroll');
			});
		}
	});

	// OPEN MAIN NAV MOBILE
	document.querySelectorAll('[data-show_nav_m]').forEach((btn) => {
		if (document.querySelector('.navigation')) {
			btn.addEventListener('click', (e) => {
				document.querySelector('.navigation').classList.add('active');
				document.body.classList.add('noscroll');
			});
		}
	});

	// ACCORDIONs
	document.querySelectorAll('[data-accordion]').forEach((acc) => {
		acc.querySelectorAll('[data-accordion_item]').forEach((item, i) => {
			const accHead = item.querySelector('[data-accordion_head]');
			const accBody = item.querySelector('[data-accordion_body]');
			accHead.addEventListener('click', (e) => {
				acc.querySelectorAll('[data-accordion_item]').forEach((citem) => {
					const cbody = citem.querySelector('[data-accordion_body]');
					if (accBody !== cbody) {
						cbody.slideUp(300, () => citem.classList.remove('active'));
					}
				});
				accBody.slideToggle(300, () => item.classList.toggle('active'));
			});

			if (i === 0) accHead.click();
		});
	});

	// TOGGLE TABS
	document.querySelectorAll('.tabsMod').forEach((mod) => {
		let activeItem = mod.querySelector('.tabsMod_item');
		let activeBtn = mod.querySelector('.js-toggleTab');

		mod.querySelectorAll('.js-toggleTab').forEach((btn, i) => {
			const currentMenu = mod.querySelector(`.tabsMod_item[data-id="${btn.dataset.id}"]`);

			btn.addEventListener('click', (e) => {
				activeItem.classList.remove('active');
				currentMenu.classList.add('active');
				activeItem = currentMenu;

				activeBtn.classList.remove('active');
				btn.classList.add('active');
				activeBtn = btn;
			});

			if (i === 0) btn.click();
		});
	});

	// TOGGLE RESTAURANT MENUS
	document.querySelectorAll('.menusMod').forEach((mod) => {
		let activeMenu = mod.querySelector('.menusMod_menu');
		let activeBtn = mod.querySelector('.js-toggleMenu');

		mod.querySelectorAll('.js-toggleMenu').forEach((btn, i) => {
			const currentMenu = mod.querySelector(`.menusMod_menu[data-id="${btn.dataset.id}"]`);

			btn.addEventListener('click', (e) => {
				activeMenu.classList.remove('active');
				currentMenu.classList.add('active');
				activeMenu = currentMenu;

				activeBtn.classList.remove('active');
				btn.classList.add('active');
				activeBtn = btn;
			});

			if (i === 0) btn.click();
		});
	});

	// TOGGLE MAIN NAV
	const mainNav = document.querySelector('.mainNav');
	if (mainNav) {
		document.querySelectorAll('.js-toggleMainNav').forEach((btn) => {
			btn.addEventListener('click', (e) => {
				mainNav.classList.toggle('active');
				document.body.classList.toggle('noscroll', mainNav.classList.contains('active'));
			});
		});
	}

	// NAV IMAGES
	document.querySelectorAll('.mainNav').forEach((mod) => {
		mod.querySelectorAll('.privary-navigation a').forEach((btn, i) => {
			const itemImage = document.querySelectorAll('.mainNav_pic img')[i];

			// SET ACTIVE IMAGE
			if (btn.classList.contains('active') && itemImage) itemImage.classList.add('active');

			// TOGGLE HOVER CLASS
			btn.addEventListener('mouseenter', () => {
				if (itemImage) itemImage.classList.add('hover');
			});
			btn.addEventListener('mouseleave', () => {
				if (itemImage) itemImage.classList.remove('hover');
			});
		});

		// FALLBACK ACTIVE IMAGE
		if (document.querySelector('.mainNav_pic') && document.querySelectorAll('.mainNav_pic .active').length < 1) document.querySelectorAll('.mainNav_pic img')[0].classList.add('active');
	});

	// CLONE SECONDARY NAV
	const secondNav = document.getElementById('secondary-nav');
	document.querySelectorAll('.js-copySecondNav').forEach((newList) => {
		if (secondNav) {
			const linksHTML = Array.from(secondNav.querySelectorAll('.secondary-navigation__item > a'))
				.map((link) => `<li>${link.outerHTML}</li>`)
				.join('');

			newList.innerHTML = linksHTML;
		}
	});

	// ANIMATE FORM LABELS ON FOCUS
	const formSelectors = '.form-module, .email-signup';
	const fieldSelectors = '.form-module__field input, .form-module__field select, .form-module__field textarea, .field.input input';
	document.querySelectorAll(formSelectors).forEach((form) => {
		form.querySelectorAll(fieldSelectors).forEach((field) => {
			field.addEventListener('focus', () => field.parentElement.classList.add('move'));
		});
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	const swiperADAduplicatedProcess = (currentSwiper) => {
		currentSwiper.slides.forEach((slide) => {
			if (slide.classList.contains('swiper-slide-duplicate')) {
				slide.setAttribute('aria-hidden', true);
				slide.setAttribute('tabindex', '-1');

				// REMOVE IDs
				slide.querySelectorAll('[id]').forEach((elementWithID) => {
					elementWithID.setAttribute('id', '');
				});

				// SET TABINDEXs -1
				slide.querySelectorAll('a').forEach((elementWithID) => {
					elementWithID.setAttribute('tabindex', '-1');
				});
			}
		});

		currentSwiper.el.querySelectorAll('.swiper-slide .swiper-pagination-bullet').forEach((dotInSlide) => {
			dotInSlide.setAttribute('tabindex', '-1');
		});
	};

	// SWIPER
	const swiperClass = '.sym-slides';
	const swiperOps = {
		speed: 1000,
		loop: true,
		fadeEffect: { crossFade: true },
		allowTouchMove: true,
		breakpoints: {
			767: {
				allowTouchMove: false,
			},
		},
		on: {
			init: function (currentSwiper) {
				swiperADAduplicatedProcess(currentSwiper);
			},
		},
	};

	document.querySelectorAll(swiperClass).forEach((slider, i) => {
		const dataOps = slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {};
		let combinedOps = Object.assign({}, swiperOps, dataOps);

		if ('pagination' in combinedOps) {
			combinedOps.pagination.renderBullet = swiperBullets;
		}

		slider.setAttribute(`data-swiper${i}`, '');
		const swiper = new Swiper(`[data-swiper${i}]`, combinedOps);

		swiper.on('slideChange', (currentSwiper) => {
			swiperADAduplicatedProcess(currentSwiper);
		});
	});

	document.querySelectorAll('[data-swiper-goto]').forEach((item) => {
		const target = item.dataset.swiperGoto ? parseInt(item.dataset.swiperGoto) : 0;
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');

		item.addEventListener('click', () => {
			slider.swiper.slideTo(target);
			item.parentNode.querySelectorAll('[data-swiper-goto]').forEach((itm) => itm.classList.remove('js-swiper_active'));
			item.classList.add('js-swiper_active');
		});
	});

	document.querySelectorAll('[data-swiper-prev]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slidePrev());
	});
	document.querySelectorAll('[data-swiper-next]').forEach((item) => {
		const slider = item.dataset.swiperTarget ? document.querySelector(item.dataset.swiperTarget) : item.closest('.sym-slides');
		item.addEventListener('click', () => slider.swiper.slideNext());
	});

	document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
		const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
		if (selectorsLinked.length < 1) {
			return false;
		}

		const slidersLinked = selectorsLinked
			.map((selector) => {
				return [...document.querySelectorAll(selector)].map((el) => el.swiper);
			})
			.flat();
		mainSlider.swiper.controller.control = slidersLinked;
	});

	function swiperBullets(index, className) {
		return `<button class="${className}">
			<span>${index + 1}</span>
			<svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' xmlns='http: //www.w3.org/2000/svg'>
				<circle cx='10' cy='10' r='9' fill='none' stroke='currentColor' stroke-width='1' pathLength="1" />
				<circle cx='10' cy='10' r='2' />
			</svg>
		</button>`;
	}

	// LBX
	const textLBX = new LBX('.js-lbx');

	// GALLERY-FLEX FULLSCRREN MODE
	if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
		customLightbox.wideArrows = true;
	}

	let factSheetPDFBtn = document.querySelector('.factSheetPDF')
	if(factSheetPDFBtn){
		factSheetPDFBtn.addEventListener('click', function() {
			this.preventDefault;
			console.log("🚀 ~ document.getElementsByClassName ~ this:", this)
			let url = this.getAttribute('href');
			let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
			if (isMobile || !isMobile) {
				window.open(url, '_blank');
			}
		});
	}
	
})();
